import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const Role = () => {
  const [selectedOption, setSelectedOption] = useState(null);
  const navigate = useNavigate();

console.log("===",selectedOption);

  const handleSubmit = async () => {
    try {
      if (selectedOption === 'donor') {
        const response = await axios.patch(`${import.meta.env.VITE_API_URL_DASHBOARD_URL}/user/donor`);
        console.log("reponse",response.data)
        navigate('/login');
      } else if (selectedOption === 'individual') {
        navigate('/onboarding/userform');
      } else if (selectedOption === 'admin') {
        navigate('/onboarding/ngoform');
      }
    } catch (error) {
      // Handle error case
      console.error('Failed to update donor role:', error);
    }
  };
  

  return (
    <div className='bg-[#FFD6FF]'>
      <div className='p-6 md:p-20 container mx-auto max-w-[90vw] md:w-[80vw] md:h-[90vh] bg-white rounded-2xl'>
        <h2 className='text-3xl text-center mt-12 mb-12'>Are You a ?</h2>
        <div className='pb-4 pt-6 flex flex-col items-center justify-center'>
          <button
            type="button"
            className={`bg-[#C8B6FF] py-2 w-[80%] md:w-80 rounded-3xl text-white focus:outline-none focus:ring-2 focus:ring-[#572b69] ${selectedOption === 'donor' ? 'selected' : ''}`}
            onClick={() => {
              setSelectedOption('donor')
              handleSubmit();
          }}
          >
            Donor
          </button>
        </div>
        <div className='pb-4 flex flex-col items-center justify-center'>
          <button
            type="button"
            className={`bg-[#C8B6FF] py-2 w-[80%] md:w-80 rounded-3xl text-white focus:outline-none focus:ring-2 focus:ring-[#572b69] ${selectedOption === 'individual' ? 'selected' : ''}`}
            onClick={() => setSelectedOption('individual')}
          >
            Individual
          </button>
        </div>
        <div className='pb-4 flex flex-col items-center justify-center'>
          <button
            type="button"
            className={`bg-[#C8B6FF] py-2 w-[80%] md:w-80 rounded-3xl text-white focus:outline-none focus:ring-2 focus:ring-[#572b69] ${selectedOption === 'admin' ? 'selected' : ''}`}
            onClick={() => setSelectedOption('admin')}
          >
            Organization
          </button>
        </div>
      </div>
    </div>
  );
};

export default Role;
